import { CONSTANTS } from "src/app/constants";
import { IGateway } from "../interfaces/gateway.interface";

export class Gateway implements IGateway {
  gatewayId: string;
  gatewayName: string;
  gatewaymodelname: string;
  Flying: number;

  constructor(gateway: IGateway) {
    Object.keys(gateway).map(key => this[key] = gateway[key]);
  }

  get isFlying(): boolean {
    return this.Flying === 1;
  }

  get isNoGateway(): boolean {
    return this.gatewayId.includes(CONSTANTS.EQUIPMENTS.NO_GATEWAY);
  }
}
